export const RESTAURANT = {
  name: "Rivaaz Indian Pizza & Cuisine",
  shortName: "Rivaaz",
  tagline: "Where Indian Flavors Meet Pizza Perfection",
  domain: "rivaaz.ca",
  url: "https://rivaaz.ca",
  phone: "+1 (403) 942-2565",
  phoneRaw: "+14039422565",
  address: "1020 Mayor Magrath Drive South, Lethbridge, AB T1K 2P8",
  city: "Lethbridge, Alberta",
  facebook: "https://facebook.com/rivaazpizza",
  orderUrl: "https://order.tbdine.com/pickup/49003/menu",
  giftCardUrl: "https://app.tableup.com/r/5220/home/giftcards",
  mapsEmbed:
    "https://www.google.com/maps?q=1020+Mayor+Magrath+Dr+S,+Lethbridge,+AB+T1K+2P8&output=embed",
  mapsLink:
    "https://www.google.com/maps/dir/?api=1&destination=1020+Mayor+Magrath+Dr+S,+Lethbridge,+AB+T1K+2P8",
  rating: "83%",
  serviceTime: "~12 min in-store · ~25 min online",
  hours: [
    { day: "Monday", time: "11:00 AM – 10:00 PM" },
    { day: "Tuesday", time: "4:00 PM – 10:00 PM" },
    { day: "Wednesday", time: "11:00 AM – 10:00 PM" },
    { day: "Thursday", time: "11:00 AM – 10:00 PM" },
    { day: "Friday", time: "11:00 AM – 10:00 PM" },
    { day: "Saturday", time: "11:00 AM – 10:00 PM" },
    { day: "Sunday", time: "11:00 AM – 10:00 PM" },
  ],
  hoursShort: [
    "Mon · 11 AM – 10 PM",
    "Tue · 4 PM – 10 PM",
    "Wed–Sun · 11 AM – 10 PM",
  ],
};

export const IMAGES = {
  heroPizza:
    "https://images.pexels.com/photos/28484142/pexels-photo-28484142.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  heroCurry:
    "https://images.unsplash.com/photo-1710091691780-c7eb0dc50cf8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  margherita:
    "https://images.pexels.com/photos/31596394/pexels-photo-31596394.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  curry:
    "https://images.pexels.com/photos/35287423/pexels-photo-35287423.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  naan: "https://images.pexels.com/photos/30203311/pexels-photo-30203311.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  spices:
    "https://images.unsplash.com/photo-1596797038530-2c107229654b?auto=format&fit=crop&w=1200&q=80",
  tandoor:
    "https://images.unsplash.com/photo-1599487488170-d11ec9c172f0?auto=format&fit=crop&w=1200&q=80",
  biryani:
    "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?auto=format&fit=crop&w=1200&q=80",
  samosa:
    "https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=1200&q=80",
  butterChicken:
    "https://images.unsplash.com/photo-1588166524941-3bf61a9c41db?auto=format&fit=crop&w=1200&q=80",
  paneer:
    "https://images.unsplash.com/photo-1631452180775-a3b3f74a3641?auto=format&fit=crop&w=1200&q=80",
  pizzaSlice:
    "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?auto=format&fit=crop&w=1200&q=80",
  wings:
    "https://images.unsplash.com/photo-1608039829572-78524f79c4c7?auto=format&fit=crop&w=1200&q=80",
  rice:
    "https://images.unsplash.com/photo-1596560548464-f010549b84d7?auto=format&fit=crop&w=1200&q=80",
  dessert:
    "https://images.unsplash.com/photo-1615484477778-ca3b77940c25?auto=format&fit=crop&w=1200&q=80",
};

// Tag legend (rendered at top of menu page)
export const TAG_LEGEND = [
  { key: "veg", label: "Vegetarian" },
  { key: "gf", label: "Gluten-Free" },
  { key: "nuts", label: "Contains Nuts" },
  { key: "spicy", label: "Spicy" },
  { key: "signature", label: "Signature" },
];

// price === null  → show note (e.g. "Choose Size", "Choose Protein")
// tags is a list of TAG_LEGEND keys
export const MENU = {
  "Appetizers": {
    intro: "Crispy, savory, and made for sharing — the perfect way to start.",
    image: "samosa",
    items: [
      { name: "Veg Samosa", price: "$6.95", desc: "Crisp turnover filled with mildly spiced potatoes and peas, deep-fried (2 pcs).", tags: ["veg"] },
      { name: "Beef Samosa", price: "$6.99", desc: "Deep-fried turnover stuffed with seasoned beef, green peas, and Indian spices (2 pcs)." },
      { name: "Chicken Pakora", price: "$8.99", desc: "Boneless chicken dipped in a special batter and fried to golden perfection (8 pcs)." },
      { name: "Veg Pakora", price: "$6.95", desc: "Fresh vegetables dipped in chickpea batter and fried to golden perfection (8 pcs).", tags: ["veg"] },
      { name: "Fish Pakora", price: "$8.99", desc: "Basa fish delicately battered with chickpea flour & spices (8 pcs)." },
      { name: "Chicken Manchurian", price: "$10.99", desc: "Eight crispy boneless chicken pieces tossed with peppers, sweet chilli, red sauce, and green onions.", tags: ["spicy"] },
      { name: "Chilli Gobhi", price: "$11.99", desc: "Cauliflower florets marinated in soya, chilli, and pepper, then deep-fried.", tags: ["veg", "spicy"] },
      { name: "Chilli Paneer", price: "$11.99", desc: "Paneer cubes tossed in soya, chilli, and pepper, deep-fried for a crisp finish.", tags: ["veg", "spicy"] },
      { name: "Rivaaz Special Platter", price: "$17.99", desc: "2 samosas (Veg or Beef), 4 fish pakoras, 4 chicken pakoras, 4 chicken wings.", tags: ["signature"] },
      { name: "Samosa Chaat", price: "$10.99", desc: "Crushed samosas topped with chickpeas, tamarind, mint chutney, and yogurt.", tags: ["veg"] },
      { name: "Paneer Tikka", price: "$10.95", desc: "Creamy cottage cheese marinated in yogurt and spices, fired in the tandoor.", tags: ["veg", "gf"] },
      { name: "Aloo Tikki", price: "$10.99", desc: "Crisp potato patties served with chickpeas, chutney, and sweet yogurt.", tags: ["veg"] },
      { name: "Chole Bhature", price: "$13.99", desc: "Puffed fried bread, chana masala, pickle, and onion slaw.", tags: ["veg"] },
      { name: "Veg Manchurian", price: "$10.99", desc: "Minced vegetable dumplings tossed with chillies, garlic, ginger, coriander, and green onion.", tags: ["veg", "spicy"] },
      { name: "Papad", price: "$3.49", desc: "Crunchy lentil & rice flour crackers.", tags: ["veg"] },
    ],
  },

  "Curry Specialties": {
    intro: "Slow-simmered, deeply spiced — choose your protein and curry style.",
    image: "curry",
    note: "Curry styles below can be made with your choice of protein. Pricing varies — please call or order online for full options.",
    items: [
      { name: "Butter Chicken", price: "$17.99", desc: "Boneless chicken breast marinated in ginger & garlic, simmered in our signature buttery tomato sauce.", tags: ["gf", "signature"] },
      { name: "Lamb Roganjosh", price: "$17.99", desc: "Famous Kashmiri lamb curry, slow-cooked with aromatic spices.", tags: ["gf", "nuts"] },
      { name: "Lababdar Chicken", price: "$18.50", desc: "Rich cashew, tomato, and onion-based gravy with tender chicken.", tags: ["nuts"] },
      { name: "Chicken Jalfrezi", price: "$17.99", desc: "Stir-fried chicken with peppers, onions, and tomatoes in a thick spicy sauce.", tags: ["spicy"] },
      { name: "Egg Curry", price: "$17.99", desc: "Hard-boiled eggs simmered in our house onion-tomato curry." },
      { name: "Tikka Masala", price: null, note: "Choose Protein", desc: "Tendered meat barbecued and simmered in a thick gravy with onions, peppers, fresh tomatoes, and herbs, finished with ginger and cilantro.", tags: ["gf"], variants: [{name:"Chicken",price:17.99},{name:"Lamb",price:19.99},{name:"Beef",price:17.99},{name:"Shrimp",price:20.99},{name:"Paneer",price:17.49}] },
      { name: "Curry", price: null, note: "Choose Protein", desc: "Tendered meat cooked in an onion-tomato sauce with ground spices.", tags: ["gf"], variants: [{name:"Chicken",price:17.99},{name:"Lamb",price:19.99},{name:"Beef",price:17.99},{name:"Shrimp",price:20.99},{name:"Paneer",price:17.49}] },
      { name: "Saag", price: null, note: "Choose Protein", desc: "Tendered meat cooked with chopped spinach and freshly ground spices.", tags: ["gf"], variants: [{name:"Chicken",price:17.99},{name:"Lamb",price:19.99},{name:"Beef",price:17.99},{name:"Paneer",price:17.49}] },
      { name: "Coconut", price: null, note: "Choose Protein", desc: "Tendered meat cooked in a coconut cream and royal spice blend.", tags: ["gf"], variants: [{name:"Chicken",price:17.99},{name:"Lamb",price:19.99},{name:"Shrimp",price:20.99}] },
      { name: "Korma", price: null, note: "Choose Protein", desc: "Tendered meat cooked in a seasoned cream sauce with onions and ground cashew nuts.", tags: ["gf", "nuts"], variants: [{name:"Chicken",price:17.99},{name:"Lamb",price:19.99},{name:"Beef",price:17.99},{name:"Paneer",price:17.49}] },
      { name: "Vindaloo", price: null, note: "Choose Protein", desc: "Tendered meat in a tangy sauce with potatoes and vinegar — a Goan specialty.", tags: ["gf", "spicy"], variants: [{name:"Chicken",price:17.99},{name:"Lamb",price:19.99},{name:"Beef",price:17.99}] },
      { name: "Kadai", price: null, note: "Choose Protein", desc: "Tendered meat with green chillies, tomatoes, peppers, onions & ginger, tempered with coriander seeds.", tags: ["spicy"], variants: [{name:"Chicken",price:17.99},{name:"Lamb",price:19.99},{name:"Beef",price:17.99},{name:"Paneer",price:17.49}] },
      { name: "Bhuna", price: null, note: "Choose Protein", desc: "Sliced beef or lamb cooked with onion, tomatoes, and Indian masala in a thick gravy.", tags: ["gf"], variants: [{name:"Beef",price:17.99},{name:"Lamb",price:19.99}] },
    ],
  },

  "Tandoori Grills": {
    intro: "Marinated, char-kissed, and pulled fresh from the clay tandoor.",
    image: "tandoor",
    items: [
      { name: "Tandoori Chicken", price: "$18.99", desc: "Half a bone-in chicken marinated in yogurt, ginger, garlic & lemon.", tags: ["gf", "signature"] },
      { name: "Shrimp Tandoori", price: "$20.99", desc: "Marinated shrimp barbecued with exotic spices.", tags: ["gf"] },
      { name: "Chicken Malai Tikka", price: "$18.99", desc: "Boneless garlic-flavoured chicken breast in a creamy ginger-garlic marinade.", tags: ["gf"] },
      { name: "Hariyali Chicken", price: "$18.99", desc: "Chicken breasts marinated in mint, coriander, yogurt, and aromatic spices.", tags: ["gf"] },
      { name: "Tandoori Fish Tikka", price: "$18.99", desc: "Fish marinated with ginger, garlic & lemon, then tandoor-grilled.", tags: ["gf"] },
      { name: "Chicken Tikka", price: "$18.99", desc: "Boneless chicken marinated in yogurt, ginger, garlic, and lemon — clay-oven baked.", tags: ["gf"] },
      { name: "Lamb Seekh Kebab", price: "$21.99", desc: "Minced lamb seasoned with spices, served with tandoori naan, salad, and mint sauce." },
      { name: "Paneer Tikka Grill", price: "$17.99", desc: "Marinated paneer cubes char-grilled in the tandoor.", tags: ["veg", "gf"] },
      { name: "Rivaaz Grill", price: "$22.99", desc: "Tandoori chicken, malai tikka, fish tikka, hariyali chicken & tandoori shrimps — the ultimate platter.", tags: ["gf", "signature"] },
    ],
  },

  "Pizzas": {
    intro: "Hand-stretched dough, our take on Indian flavors meeting pizza perfection.",
    image: "margherita",
    note: "Available in multiple sizes — choose size at checkout.",
    items: [
      { name: "Butter Chicken Pizza", price: null, note: "Choose Size", desc: "Creamy butter sauce, mozzarella, bell peppers, red onions, butter chicken, fresh cilantro.", tags: ["signature"], variants: [{name:"10\" Small",price:17.99},{name:"15\" Large",price:27.99}] },
      { name: "Tandoori Chicken Pizza", price: null, note: "Choose Size", desc: "White garlic sauce, cheese, bell peppers, red onions, diced tomatoes, tandoori chicken, cilantro.", variants: [{name:"10\" Small",price:17.99},{name:"15\" Large",price:27.99}] },
      { name: "Shahi Paneer Pizza", price: null, note: "Choose Size", desc: "Creamy shahi sauce, cheese, peppers, red onions, tomatoes, black olives, green onions, masala paneer, cilantro.", tags: ["veg", "signature"], variants: [{name:"10\" Small",price:17.99},{name:"15\" Large",price:27.99}] },
      { name: "Gourmet Veggie Pizza", price: null, note: "Choose Size", desc: "House red sauce, cheese, mushrooms, peppers, red onions, diced tomatoes, black olives, cilantro.", tags: ["veg"], variants: [{name:"10\" Small",price:15.99},{name:"15\" Large",price:25.99}] },
      { name: "Meat Lovers Pizza", price: null, note: "Choose Size", desc: "House red sauce, cheese, ham, pepperoni, bacon, beef.", variants: [{name:"10\" Small",price:17.49},{name:"15\" Large",price:27.49}] },
      { name: "Hawaiian Pizza", price: null, note: "Choose Size", desc: "House red sauce, cheese, ham, pineapple.", variants: [{name:"10\" Small",price:14.99},{name:"15\" Large",price:23.99}] },
      { name: "Corn Tomato Pizza", price: null, note: "Choose Size", desc: "House pizza sauce, cheese, mushrooms, sweet corn, pineapple, green peppers.", tags: ["veg"], variants: [{name:"10\" Small",price:14.99},{name:"15\" Large",price:23.99}] },
      { name: "Pepperoni Pizza", price: null, note: "Choose Size", desc: "House red sauce, cheese, classic pepperoni.", variants: [{name:"10\" Small",price:13.99},{name:"15\" Large",price:22.99}] },
      { name: "Cheese Pizza", price: null, note: "Choose Size", desc: "House red sauce and a generous layer of melted cheese.", tags: ["veg"], variants: [{name:"10\" Small",price:12.99},{name:"15\" Large",price:21.99}] },
      { name: "Veggie Supreme Pizza", price: null, note: "Choose Size", desc: "Loaded with our chef's selection of fresh vegetables.", tags: ["veg"], variants: [{name:"10\" Small",price:15.99},{name:"15\" Large",price:25.99}] },
    ],
  },

  "Vegetarian Dishes": {
    intro: "Hearty, comforting plates rooted in centuries of vegetarian Indian cooking.",
    image: "paneer",
    items: [
      { name: "Shahi Paneer", price: "$17.99", desc: "Cottage cheese in a thick gravy of cream, cardamom, tomatoes, and Indian masala.", tags: ["veg", "gf"] },
      { name: "Kadai Paneer", price: "$17.99", desc: "Stir-fried cottage cheese with fresh tomatoes, onions, bell peppers, and kadai masala.", tags: ["veg"] },
      { name: "Paneer Tikka Masala", price: "$17.99", desc: "Cottage cheese cooked in tikka masala sauce with cream and tomato.", tags: ["veg", "gf"] },
      { name: "Saag Paneer", price: "$17.49", desc: "Cottage cheese with baby spinach, mustard greens, and Indian masala.", tags: ["veg", "gf"] },
      { name: "Matar Paneer", price: "$17.99", desc: "Cooked with fenugreek leaves, green peas, Indian spices, and herbs.", tags: ["veg", "gf"] },
      { name: "Paneer Lababdar", price: "$18.49", desc: "Cottage cheese cubes in a creamy slow-cooked onion, cashew, and tomato sauce.", tags: ["veg", "nuts"] },
      { name: "Bengan Bhartha", price: "$17.49", desc: "Roasted eggplant sautéed with onions, tomatoes, and spices.", tags: ["veg", "gf"] },
      { name: "Daal Makhni", price: "$15.99", desc: "Lentils and kidney beans slow-cooked with butter and spices.", tags: ["veg", "gf"] },
      { name: "Daal Tadka", price: "$15.49", desc: "Home-style mixed lentils, finished with tempered spices.", tags: ["veg", "gf"] },
      { name: "Bhindi Do Pyaza", price: "$17.49", desc: "Okra sautéed with tomatoes, onions, garlic, and spices, topped with cilantro.", tags: ["veg", "gf"] },
      { name: "Navratan Korma", price: "$16.99", desc: "Creamy curry with nuts, paneer, and a variety of vegetables.", tags: ["veg", "gf", "nuts"] },
      { name: "Aloo Gobi", price: "$16.99", desc: "Potatoes and cauliflower cooked with onions, tomatoes, and spices.", tags: ["veg", "gf"] },
      { name: "Chana Masala", price: "$15.99", desc: "Flavourful chickpea curry in a spicy onion-tomato masala gravy.", tags: ["veg", "gf"] },
      { name: "Vegetable Jalfrezi", price: "$16.99", desc: "Stir-fried vegetables in a thick spicy sauce with chillies, onions, and tomatoes.", tags: ["veg", "spicy"] },
    ],
  },

  "Rice Specialties": {
    intro: "Fragrant basmati layered with saffron, herbs, and slow-cooked goodness.",
    image: "biryani",
    items: [
      { name: "Chicken Biryani", price: "$18.49", desc: "Fragrant rice and marinated chicken cooked on dum with aromatic Indian spices.", tags: ["gf", "signature"] },
      { name: "Lamb Biryani", price: "$19.49", desc: "Fragrant rice and lamb shanks cooked on dum with aromatic Indian spices.", tags: ["gf"] },
      { name: "Beef Biryani", price: "$18.49", desc: "Fragrant rice and marinated beef cooked on dum with aromatic Indian spices.", tags: ["gf"] },
      { name: "Shrimp Biryani", price: "$19.49", desc: "Tiger shrimp cooked with basmati rice, herbs, and spices.", tags: ["gf"] },
      { name: "Vegetable Biryani", price: "$17.49", desc: "Fragrant rice and vegetables cooked on dum with aromatic Indian spices.", tags: ["veg", "gf"] },
      { name: "Fish Biryani", price: "$18.49", desc: "Fragrant rice with marinated fish cooked on dum.", tags: ["gf"] },
      { name: "Kashmiri Pulao Rice", price: "$6.99", desc: "Rice with saffron, vegetables, raisins, cashews, and coconut.", tags: ["veg", "nuts"] },
      { name: "Saffron Rice", price: "$6.99", desc: "Basmati rice steamed with saffron.", tags: ["veg", "gf"] },
      { name: "Coconut Rice", price: "$6.99", desc: "Basmati rice with mustard seeds, curry leaves, coconut powder, and cream.", tags: ["veg", "gf"] },
      { name: "Jeera Rice", price: "$5.99", desc: "Basmati rice sautéed with cumin seeds.", tags: ["veg", "gf"] },
      { name: "Steamed Rice", price: "$4.25", desc: "Plain steamed basmati rice.", tags: ["veg", "gf"] },
      { name: "Fried Rice", price: "$13.99", desc: "Wok-tossed rice with vegetables and our house seasoning." },
    ],
  },

  "Tandoori Breads": {
    intro: "Pulled fresh from the tandoor — every order, every time.",
    image: "naan",
    items: [
      { name: "Tandoori Naan", price: "$2.99", desc: "Soft and chewy white-flour bread.", tags: ["veg"] },
      { name: "Garlic Naan", price: "$3.50", desc: "Soft naan topped with fresh garlic paste.", tags: ["veg", "signature"] },
      { name: "Cheese Naan", price: "$5.99", desc: "Pillowy naan stuffed with melted cheese.", tags: ["veg"] },
      { name: "Coconut Naan", price: "$6.00", desc: "Soft naan filled with sweet coconut.", tags: ["veg"] },
      { name: "Keema Naan", price: "$6.49", desc: "Soft naan filled with spiced minced lamb." },
      { name: "Spicy Naan", price: "$3.75", desc: "Naan kneaded with green chillies for a fiery kick.", tags: ["veg", "spicy"] },
      { name: "Tandoori Roti", price: "$3.50", desc: "Whole wheat bread cooked in the clay oven.", tags: ["veg"] },
      { name: "Garlic Roti", price: "$3.75", desc: "Whole wheat bread with sliced garlic, tandoor-baked.", tags: ["veg"] },
      { name: "Lachha Paratha", price: "$5.00", desc: "Flaky multi-layered whole wheat flatbread.", tags: ["veg"] },
    ],
  },

  "Wings": {
    intro: "Crispy, saucy, and fired up six different ways.",
    image: "wings",
    items: [
      { name: "Lemon Pepper Wings", price: "$9.95", desc: "Crispy wings tossed with bright lemon and cracked pepper." },
      { name: "Honey Garlic Wings", price: "$12.49", desc: "Sticky, sweet honey-garlic glaze." },
      { name: "Spicy Wings", price: "$12.49", desc: "Hot and bold — for the spice chasers.", tags: ["spicy"] },
      { name: "Tandoori Chicken Wings", price: "$12.49", desc: "Wings marinated in tandoori spices and clay-oven baked.", tags: ["gf", "signature"] },
      { name: "Dill Pickle Wings", price: "$12.49", desc: "Tangy dill pickle seasoning — surprisingly addictive." },
    ],
  },

  "Salads": {
    intro: "Crisp, fresh, and a perfect counterpoint to our big flavors.",
    image: "spices",
    items: [
      { name: "Mixed Cucumber Salad", price: "$7.99", desc: "Cucumbers, red onions, lettuce, tomatoes, and chef's special dressing.", tags: ["veg", "gf"] },
      { name: "Onion Salad", price: "$4.99", desc: "Sliced onions with lemon juice and chef's special dressing.", tags: ["veg", "gf"] },
    ],
  },

  "Sides & Sauces": {
    intro: "House-made dips, chutneys, and accompaniments.",
    image: "spices",
    items: [
      { name: "Raita", price: "$4.99", desc: "Yogurt with diced cucumbers and seasonings.", tags: ["veg", "gf"] },
      { name: "Raita (Small)", price: "$3.00", desc: "Smaller portion of our cool yogurt raita.", tags: ["veg", "gf"] },
      { name: "Mint Dip", price: "$3.00", desc: "Cool, herby mint chutney.", tags: ["veg"] },
      { name: "Mango Chutney", price: "$3.00", desc: "Sweet, tangy mango chutney.", tags: ["veg"] },
      { name: "Butter Sauce", price: "$3.00", desc: "Creamy butter masala sauce on the side.", tags: ["veg"] },
      { name: "Plain Yogurt", price: "$5.00", desc: "Cool, fresh yogurt.", tags: ["veg", "gf"] },
      { name: "Cheddar Chipotle Dip", price: "$2.00", desc: "Smoky chipotle and sharp cheddar.", tags: ["veg"] },
      { name: "Creamy Garlic Dip", price: "$2.00", desc: "Cool, garlicky, dippable.", tags: ["veg"] },
      { name: "Ranch Dip", price: "$2.00", desc: "Classic creamy ranch.", tags: ["veg"] },
      { name: "Mix Pickle", price: "$2.00", desc: "Traditional Indian mixed pickle.", tags: ["veg"] },
    ],
  },

  "Desserts": {
    intro: "Sweet, fragrant, and the perfect way to end the meal.",
    image: "dessert",
    items: [
      { name: "Gulab Jamun", price: "$6.00", desc: "Soft milk-powder dumplings soaked in rosewater-scented sugar syrup.", tags: ["veg"] },
      { name: "Rasmalai", price: "$6.00", desc: "Creamy cheese balls smoked in cardamom-flavoured milk syrup.", tags: ["veg"] },
      { name: "Kheer", price: "$6.00", desc: "Slow-cooked Indian-style rice pudding.", tags: ["veg", "gf"] },
      { name: "Vanilla Ice Cream", price: "$6.00", desc: "Classic vanilla bean ice cream.", tags: ["veg", "gf"] },
      { name: "Mango Ice Cream", price: "$6.00", desc: "Cool, fragrant mango ice cream.", tags: ["veg", "gf"] },
      { name: "Chocolate Ice Cream", price: "$6.00", desc: "Rich chocolate ice cream.", tags: ["veg", "gf"] },
      { name: "Butter Scotch Ice Cream", price: "$7.00", desc: "Buttery, caramel-kissed ice cream.", tags: ["veg", "gf"] },
    ],
  },

  "Combo Meals": {
    intro: "Built to share — feast-ready combos for the family table.",
    image: "biryani",
    items: [
      { name: "Meal 1", price: "$47.00", desc: "2 veg samosas, 10\" pizza (any 1), curry (any 1), steamed rice, 2 garlic or tandoori naan, gulab jamun.", tags: ["signature"] },
      { name: "Meal 2", price: "$94.00", desc: "4 veg samosas, 15\" pizza (any 1), 2 curries, 2 steamed rice, 4 garlic or tandoori naan, 4 cans of pop." },
      { name: "Meal 3", price: "$47.00", desc: "Any 2 curries, 2 garlic or tandoori naan, 1 rice, 2 veg samosas, 1 gulab jamun." },
    ],
  },

  "Drinks": {
    intro: "Cool down with a lassi, sip a masala chai, or grab something fizzy.",
    image: "spices",
    items: [
      { name: "Masala Chai", price: "$4.00", desc: "Spiced black tea simmered with milk, cardamom, and ginger.", tags: ["veg"] },
      { name: "Coffee", price: "$3.99", desc: "Freshly brewed coffee.", tags: ["veg"] },
      { name: "Lassi", price: null, note: "Choose Flavour", desc: "Sweet, salted, or mango — the classic yogurt drink.", tags: ["veg", "gf"], variants: [{name:"Sweet",price:5.99},{name:"Salted",price:5.99},{name:"Mango",price:6.49}] },
      { name: "Milkshake", price: null, note: "Choose Flavour", desc: "Thick, blended milkshake — multiple flavours.", tags: ["veg"], variants: [{name:"Vanilla",price:6.99},{name:"Chocolate",price:6.99},{name:"Mango",price:6.99},{name:"Strawberry",price:6.99}] },
      { name: "Juice", price: null, note: "Choose Flavour", desc: "Fresh juice selection.", tags: ["veg", "gf"], variants: [{name:"Orange",price:4.49},{name:"Apple",price:4.49},{name:"Mango",price:4.99}] },
      { name: "Canned Pop", price: "$0.25", desc: "Coke, Diet Coke, Sprite & more.", tags: ["veg"] },
    ],
  },
};

export const TESTIMONIALS = [
  {
    name: "Priya S.",
    quote:
      "Best Butter Chicken Pizza I've ever had. The crust holds up to the curry — pure genius.",
    rating: 5,
  },
  {
    name: "Marcus T.",
    quote:
      "Lethbridge's hidden gem. The Rivaaz Grill is unreal and the naan is bakery-fresh.",
    rating: 5,
  },
  {
    name: "Aisha K.",
    quote:
      "Authentic flavors, fast service, and friendly staff. We order from Rivaaz at least once a week.",
    rating: 5,
  },
  {
    name: "Daniel R.",
    quote:
      "I came for pizza, stayed for the lamb roganjosh. Now I bring everyone here.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "How do I place an order?",
    a: "Order online for pickup at rivaaz.ca (linked from every Order Now button), or call us at +1 (403) 942-2565. Online pickup orders are typically ready in about 25 minutes.",
  },
  {
    q: "Do you offer vegetarian, vegan, and gluten-free options?",
    a: "Yes — our entire Vegetarian Dishes section, plus most paneer, daal, and vegetable items are vegetarian. Many of our curries, biryanis, and tandoori grills are gluten-free (marked GF on the menu). Let us know your needs when ordering and we'll guide you.",
  },
  {
    q: "What payment methods do you accept?",
    a: "Cash, all major credit/debit cards, Apple Pay, and contactless payments.",
  },
  {
    q: "What are your hours?",
    a: "Mon, Wed, Thu, Fri, Sat, Sun: 11:00 AM – 10:00 PM. Tuesday: 4:00 PM – 10:00 PM. Online orders close 30 minutes before we do (9:30 PM) so the kitchen can wrap up.",
  },
  {
    q: "Do you offer dine-in and takeout?",
    a: "Yes — dine in with us, grab takeout, or order online for pickup. Free parking on site.",
  },
  {
    q: "Do you sell gift cards?",
    a: "Yes — digital gift cards are available. Visit our gift card link or ask in-store.",
  },
  {
    q: "Where are you located?",
    a: "1020 Mayor Magrath Drive South, Lethbridge, AB T1K 2P8.",
  },
];
